import { Component } from '@angular/core';

@Component({
  selector: 'app-imprint',
  standalone: false,
  
  templateUrl: './imprint.component.html',
  styleUrl: './imprint.component.scss'
})
export class ImprintComponent {

}
